import React from "react";
import {
  ClientContainer,
  withContainers,
} from "../../containers/gamification";
import { ShoppingCartContainer } from "../../containers/gamification2026";

import CartButtons from "./CartButtons";
import CartWarning from "./CartWarning";
import CartItemsTable from "./CartItemsTable";
import EmptyStateLayout from "../shared/EmptyStateLayout";
import { ReactComponent as NoStore } from "../../../assets/img/no_store.svg";
import CustomLink from "../shared/CustomLink";
import PopUp from "../shared/PopUp";
import { t } from "../../../i18n";
import CartContainer from "./CartContainer";

const CartItems = (props) => {
  const {
    client = {},
    cart,
    onIncreaseItem,
    onDecreaseItem,
    onRemoveItem,
    checkout,
    campaign,
    campaignUser,
    onReturnToCatalog,
    onCheckCartItem,
  } = props;

  const message = t("gamification2026.cart.add-items-link");
  const path = `/catalog`;

  var allowed = true;
  var toRemove = [];

  function checkforcard() {
    if (cart.items.length <= 1) return;

    // An item is "exclusive" when it requires a dedicated checkout (cards,
    // and in future vouchers — any product with is_a_card === true).
    // Rules:
    //  1. Exclusive items must not share a cart with non-exclusive items.
    //  2. All exclusive items in the cart must be the same product type
    //     (no mixing different card types / card + voucher).
    //
    // "toRemove" collects the names of offending items shown to the user.

    const exclusiveItems = cart.items.filter(
      (item) => item.product.is_a_card === true && item.requires_separate_checkout === true
    );
    const regularItems = cart.items.filter(
      (item) => !item.product.is_a_card || item.requires_separate_checkout !== true
    );

    if (exclusiveItems.length === 0) return; // no exclusive items → normal cart

    // Rule 1 — exclusive items mixed with regular products
    if (regularItems.length > 0) {
      allowed = false;
      regularItems.forEach((item) => toRemove.push(item.product.name));
      return;
    }

    // Rule 2 — multiple different exclusive product types (different card types)
    // Group by product.id; if more than one distinct id is present, block.
    const exclusiveProductIds = [...new Set(exclusiveItems.map((item) => item.product.id))];
    if (exclusiveProductIds.length > 1) {
      allowed = false;
      // Suggest removing all but the first card type
      const firstId = exclusiveProductIds[0];
      exclusiveItems
        .filter((item) => item.product.id !== firstId)
        .forEach((item) => toRemove.push(item.product.name));
    }
  }

  return cart.items.length > 0 ? (
    <>
      {checkforcard()}
      <CartContainer
        currencyLabel={client.currency_label}
        cart={cart}
        campaign={campaign}
        campaignUser={campaignUser}
        onCheckCartItem={onCheckCartItem}
        onIncreaseItem={onIncreaseItem}
        onDecreaseItem={onDecreaseItem}
        onRemoveItem={onRemoveItem}
        checkout={checkout}
      />
      {allowed == false && (
        <PopUp isOpenValue={true} title={t("gamification2026.cart.attention")}>
          <div className="gl2026-modal__callout gl2026-modal__callout--warning">
            <div className="gl2026-modal__callout-content">
              <p className="gl2026-modal__callout-text">
                {t("gamification2026.cart.card-only-warning")}
              </p>
              <p className="gl2026-modal__callout-text">
                {t("gamification2026.cart.remove-products-warning")}
              </p>
              {toRemove.map((item) => (
                <p key={item} className="gl2026-modal__callout-text">— {item}</p>
              ))}
            </div>
          </div>
        </PopUp>
      )}
    </>
  ) : (
    <div>
      <EmptyStateLayout message={message}>
        <div className="gl-no-store">
          <NoStore className="mr-3 dead-grey gl-no-store__image"></NoStore>
        </div>
        <h2 className="mb-5">{t("gamification2026.cart.empty-cart")}</h2>
      </EmptyStateLayout>
      <div className="flex justify-center">
        <CustomLink to={path} primary>
          {t("gamification2026.cart.prize-store")}
        </CustomLink>
      </div>
    </div>
  );
};

export default withContainers(CartItems, [
  ShoppingCartContainer,
  ClientContainer,
]);
